import { isPublicOrderId } from '../../shared/publicOrderId.ts'
import { stagingQaRuntimeAllowed } from './runtimeEnvironment'

export const approvedBankTransferBootstrap = {
  accountName: 'KYLE LAWSON',
  accountNumber: '02-1266-0126238-000',
} as const

const BANK_CONFIRMATION_STORAGE_PREFIX = 'sg.checkout.bank-transfer.v1:'

function readOrderBankTransferSnapshot() {
  if (typeof window === 'undefined') return null
  const confirmationPath = window.location.pathname.replace(/\/+$/, '')
  if (confirmationPath !== '/checkout/confirmation') return null
  const params = new URLSearchParams(window.location.search)
  const orderId = params.get('order') ?? ''
  if (!isPublicOrderId(orderId)) return null
  try {
    const raw = window.sessionStorage.getItem(`${BANK_CONFIRMATION_STORAGE_PREFIX}${orderId}`)
    if (!raw) return null
    const parsed = JSON.parse(raw) as Record<string, unknown>
    if (parsed.version !== 1
      || typeof parsed.accountName !== 'string'
      || typeof parsed.accountNumber !== 'string') return null
    return { accountName: parsed.accountName, accountNumber: parsed.accountNumber }
  } catch {
    return null
  }
}

function qaBankTransferSnapshot() {
  if (typeof window === 'undefined') return null
  const params = new URLSearchParams(window.location.search)
  if (!stagingQaRuntimeAllowed(window.location.hostname) || params.get('qa-preview') !== 'bank-transfer') return null
  return approvedBankTransferBootstrap
}

export function getBankTransferConfirmationSnapshot() {
  return readOrderBankTransferSnapshot() ?? qaBankTransferSnapshot()
}

const confirmationSnapshot = getBankTransferConfirmationSnapshot()

export const bankTransferConfig = {
  accountName: confirmationSnapshot?.accountName ?? '',
  accountNumber: confirmationSnapshot?.accountNumber ?? '',
  pendingMessage: 'Please make the bank transfer within 2 hours. Your order is not marked paid until the transfer is received and confirmed.',
  checkoutInstructions: 'Bank details and your unique Sugar Gremlin order reference will be shown after you place your order. Use the exact reference shown so we can match your payment.',
} as const
